module.exports = __webpack_public_path__ + "030bbb1caf94aae2229b73ab68b82f9f.svg";